import "./ParentGuideResources.module.css";
import Header from "@/reusable_sections/Header";
import ParentResourcesIntro from "./sections/ParentResourcesIntro";
import Articles from "./sections/Articles";
import Footer from "@/reusable_sections/Footer";
import ProgramGuide from "./sections/ProgramGuide";
import SessionFlow from "./sections/SessionFlow";
import Pillars from "./sections/Pillars";
export default function ParentGuideResourcesPage() {
  return <div>
      <Header />
      <ParentResourcesIntro />
      <ProgramGuide id="parent-journey" />
      <SessionFlow id="parent-session-visual" />
      <Pillars id="why-parents-trust" />
      <Articles />
      <Footer />
    </div>;
}